import {
  SAVE_TEST_PROGRESS_REQUEST,
  SAVE_TEST_PROGRESS_SUCCESS,
  SAVE_TEST_PROGRESS_FAILURE,
  FETCH_TESTS_REQUEST,
  FETCH_TESTS_SUCCESS,
  FETCH_TESTS_FAILURE,
  FETCH_TEST_REQUEST,
  FETCH_TEST_SUCCESS,
  FETCH_TEST_FAILURE,
  DELETE_TEST_REQUEST,
  DELETE_TEST_SUCCESS,
  DELETE_TEST_FAILURE,
  UPDATE_TEST_REQUEST,
  UPDATE_TEST_SUCCESS,
  UPDATE_TEST_FAILURE,
  FETCH_USER_ANSWER_HISTORY_REQUEST,
  FETCH_USER_ANSWER_HISTORY_SUCCESS,
  FETCH_USER_ANSWER_HISTORY_FAILURE,
  FETCH_USER_PERFORMANCE_REQUEST,
  FETCH_USER_PERFORMANCE_SUCCESS,
  FETCH_USER_PERFORMANCE_FAILURE,
  CLEAR_CURRENT_TEST
} from './TestProgressTypes';

const initialState = {
  tests: [],
  currentTest: null,
  userAnswerHistory: {},
  userPerformance: null,
  loading: false,
  error: null,
  success: false,
  // H7: per-operation flags to prevent state bleed between concurrent operations
  saveLoading: false,
  fetchLoading: false,
  deleteLoading: false
};

export const testProgressReducer = (state = initialState, action) => {
  switch (action.type) {
    // H7: separate loading flags per operation to prevent state bleed
    case SAVE_TEST_PROGRESS_REQUEST:
      return {
        ...state,
        saveLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case FETCH_TESTS_REQUEST:
    case FETCH_TEST_REQUEST:
    case FETCH_USER_ANSWER_HISTORY_REQUEST:
    case FETCH_USER_PERFORMANCE_REQUEST:
      return {
        ...state,
        fetchLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case DELETE_TEST_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case UPDATE_TEST_REQUEST:
      return {
        ...state,
        saveLoading: true,
        loading: true,
        error: null,
        success: false
      };

    case SAVE_TEST_PROGRESS_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        // C3 fix: merge with existing currentTest to preserve fields not in the save payload
        currentTest: state.currentTest
          ? { ...state.currentTest, ...action.payload }
          : action.payload,
        success: true
      };

    case FETCH_TESTS_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        tests: action.payload,
        success: true
      };

    case FETCH_TEST_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        currentTest: action.payload,
        success: true
      };

    case DELETE_TEST_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        loading: state.saveLoading || state.fetchLoading,
        tests: state.tests.filter(test => test.testId !== action.payload),
        success: true
      };

    case UPDATE_TEST_SUCCESS:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        currentTest: state.currentTest
          ? { ...state.currentTest, ...action.payload }
          : action.payload,
        tests: state.tests.map(test =>
          test.testId === action.payload.testId
            ? { ...test, ...action.payload }
            : test
        ),
        success: true
      };

    case CLEAR_CURRENT_TEST:
      return {
        ...state,
        currentTest: null
      };

    case FETCH_USER_ANSWER_HISTORY_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        userAnswerHistory: action.payload,
        success: true
      };

    case FETCH_USER_PERFORMANCE_SUCCESS:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        userPerformance: action.payload,
        success: true
      };

    case SAVE_TEST_PROGRESS_FAILURE:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        error: action.payload,
        success: false
      };

    case DELETE_TEST_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        loading: state.saveLoading || state.fetchLoading,
        error: action.payload,
        success: false
      };

    case UPDATE_TEST_FAILURE:
      return {
        ...state,
        saveLoading: false,
        loading: state.fetchLoading || state.deleteLoading,
        error: action.payload,
        success: false
      };

    case FETCH_TESTS_FAILURE:
    case FETCH_TEST_FAILURE:
    case FETCH_USER_ANSWER_HISTORY_FAILURE:
    case FETCH_USER_PERFORMANCE_FAILURE:
      return {
        ...state,
        fetchLoading: false,
        loading: state.saveLoading || state.deleteLoading,
        error: action.payload,
        success: false
      };

    default:
      return state;
  }
};
